const XD_FEEDBACK_MESSAGES = [
  {
    en: 'Creative does not contain sufficient brand notification',
    ja:
      'クリエイティブにブランド名（商品名・店舗名など）が記載されていません。 クリエイティブにブランド名を追加して、再度入稿して下さい。',
  },
  {
    en: 'Pornography, nudity, obscenity, or other “adult” content',
    ja:
      'アダルトコンテンツ等、成人向けクリエイティブのため、却下されています。',
  },
  {
    en: 'Creative does not display properly',
    ja:
      'クリエイティブが正しく表示できません。 クリエイティブが画面上で正しく表示される場合はサポートまでお問い合わせ下さい。',
  },
  {
    en: 'Creative does not click through properly',
    ja:
      '遷移先URLに遷移できません（一部アクセス制限、LPが公開されていない等）。 正しく遷移出来る場合お問い合わせ下さい。',
  },
  {
    en: 'Creative brand does not match creative landing page',
    ja:
      '遷移先URLに遷移できません（一部アクセス制限、LPが公開されていない等）。 正しく遷移出来る場合お問い合わせ下さい。',
  },
  {
    en: 'Pornography, nudity, obscenity, or other adult content',
    ja:
      'クリエイティブに記載されているブランド名（商品名・店舗名など）と、遷移先webページで記載されているブランド名が一致しません。',
  },
]

export const getXDFeedbackMessage = originalMessage => {
  return XD_FEEDBACK_MESSAGES.find(
    xdMessage => originalMessage === xdMessage.en,
  )
}
